import React, { useEffect, useState } from "react"
import { getCountries } from "../services/country"

export default function useCountries() {
  const [isLoading, setIsLoading] = useState(true)
  const [countries, setCountries] = useState([])
  const [errors, setErrors] = useState({})

  useEffect(() => {
    const fetchCountries = async () => {
      setIsLoading(true)
      try {
        const countries = await getCountries()

        setCountries(countries)
      } catch (error) {
        if (error.response) {
          const { data } = error.response
          if (data && data.errors) {
            setErrors(data.errors)
          } else {
            setErrors({ general: ["حدث خطأ غير متوقع. حاول مرة أخرى لاحقًا."] })
          }
        } else if (error.request) {
          setErrors({ general: ["لم يتم تلقي استجابة من الخادم. حاول مرة أخرى لاحقًا."] })
        } else {
          setErrors({ general: ["حدث خطأ أثناء إعداد الطلب. حاول مرة أخرى لاحقًا."] })
        }
      } finally {
        setIsLoading(false)
      }
    }
    fetchCountries()
  }, [])

  return { isLoading, countries, errors }
}
